import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

const Dato = ({styles, elemento}) => {
  return(
    <p style={styles.elemLis_1}>{elemento.descrUndMat}</p>
  )};

const DescrTiUndMat = props => <p>{props.elemento.descrTiUndMat}</p>;

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return (
    <div className="ui middle aligned animated celled link list" style={styles.listaDer}>
      <div className="item">
        <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
            <div className="right floated content" style={styles.elemLis_2}>
                <div><DescrTiUndMat elemento={elemento.tiundmat} /></div>
            </div>
            <List.Header>
                <div className="floated content" style={styles.subElemLis_1}>
                    <a className="header"><Dato styles={styles} elemento={elemento}/></a>
                </div>
            </List.Header>
        </List.Item>
      </div>
    </div>
  )
};

const Lista = ({styles, list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} handleClickidLista={handleClickidLista} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      {nivel1Detalle}
    </div>
  )
};

const DirUm2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a01052501 = autorizacUA.findIndex( autorizac => autorizac === "01052501" );

  return (
    <div>
      <List selection>
      <TitDer list={list} textBoton1="Unidades Matrices" btnNuevo={a01052501!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />

      <Lista list={list} styles={styles} handleClickidLista={handleClickidLista}/>
      </List>
    </div>
  )
};

export default DirUm2
